// extracted by mini-css-extract-plugin
export var numpadContainer = "_qw-1";
export var phoneButton = "_qw-0";